import { Box, LinearProgress, makeStyles } from '@material-ui/core';
import { isIframe } from 'src/routes';

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    left: 0,
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 2000
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    width: '100%'
  }
}));

const SplashScreen = () => {
  const classes = useStyles();

  if (isIframe()) {
    return null;
  }

  return (
    <div className={classes.root}>
      <Box width={'80%'}>
        <LinearProgress />
      </Box>
    </div>
  );
};

export default SplashScreen;
